export const WIZARD_SET_PAGE_COUNT = 'WIZARD_SET_PAGE_COUNT';
export const WIZARD_PAGE_NEXT = 'WIZARD_PAGE_NEXT';
export const WIZARD_PAGE_SKIP = 'WIZARD_PAGE_SKIP';
export const WIZARD_PAGE_PREV = 'WIZARD_PAGE_PREV';
export const WIZARD_DONE = 'WIZARD_DONE';
export const WIZARD_RESET = 'WIZARD_RESET';
export const WIZARD_SET_DEVICE = 'WIZARD_SET_DEVICE';
export const WIZARD_ERROR = 'WIZARD_ERROR';
export const WIZARD_ALERT = 'WIZARD_ALERT';

export const DEVICE_SET_INFO = 'DEVICE_SET_INFO';
export const DEVICE_SET_TARGET = 'DEVICE_SET_TARGET';
export const DEVICE_SET_SECONDARY_TARGET = 'DEVICE_SET_SECONDARY_TARGET';
export const DEVICE_SET_RELEASE_VERSION = 'DEVICE_SET_RELEASE_VERSION';

export const MANAGE_REPLACE_START = 'MANAGE_REPLACE_START';
export const MANAGE_RETIRE_START = 'MANAGE_RETIRE_START';
export const MANAGE_RESET = 'MANAGE_RESET';
export const MANAGE_REPROVISION_DEVICE_START =
  'MANAGE_REPROVISION_DEVICE_START';
export const MANAGE_ENABLE_FAT_START = 'MANAGE_ENABLE_FAT_START';
export const MANAGE_ENABLE_OAT_START = 'MANAGE_ENABLE_OAT_START';
export const MANAGE_PROVISION_START = 'MANAGE_PROVISION_START';
export const MANAGE_IDENTIFICATION_START = 'MANAGE_IDENTIFICATION_START';
export const MANAGE_DISCOVERY_START = 'MANAGE_DISCOVERY_START';

export const USER_SET_USER = 'USER_SET_USER';

export const SET_RETIRE_REASON = 'SET_RETIRE_REASON';
